import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, startHeartbeat } from "@/lib/analytics";

/**
 * Silently records every route change into the analytics store.
 * Mount once inside <BrowserRouter> in App.js.
 */
export function AnalyticsTracker() {
  const loc = useLocation();

  // Fire a pageview on every path/search change
  useEffect(() => {
    // Extract tool slug if this is a tool detail page
    const m = /^\/tool\/([^/?#]+)/.exec(loc.pathname);
    const tool_slug = m ? decodeURIComponent(m[1]) : null;
    trackPageview(loc.pathname + loc.search, { tool_slug });
  }, [loc.pathname, loc.search]);

  // Start the heartbeat once for the tab's lifetime
  useEffect(() => {
    const stop = startHeartbeat();
    return stop;
  }, []);

  return null;
}
